{
  "helpMessage": "<h3>Got questions?</h3><p>We’re happy to help - call our team:<br/><a><strong>☎️ {{phone}}</strong></a> (then press <strong>Option 2</strong>)<br/>Monday to Friday, 8am–5pm.</p>",
  "text": "<p>We’ll let your referring doctor know, and they may follow up with you to discuss next steps.</p> <p>There’s nothing else you need to do for now.</p>",
  "title": "You’ve chosen not to book right now"
}
